/**
 * SYNQ API base URL resolver
 * --------------------------
 * Auto-uses same-origin (`""` → relative `/api` URLs) whenever the running page is
 * served from a domain different than the one baked into REACT_APP_BACKEND_URL.
 *
 * This makes the app "just work" on:
 *   • preview          → REACT_APP_BACKEND_URL is same-origin → use env URL
 *   • emergent.host    → same-origin → use env URL
 *   • custom domain    → host differs → use "" (relative), routes through ingress
 *
 * It also bypasses cross-origin credentialed CORS issues caused by edge proxies
 * that emit Access-Control-Allow-Origin: *.
 */
function resolveApiBase() {
  const env = process.env.REACT_APP_BACKEND_URL || "";
  if (typeof window === "undefined") return env;
  if (!env) return ""; // already same-origin
  try {
    const envHost = new URL(env).host;
    if (envHost !== window.location.host) return ""; // same-origin fallback
  } catch (_) {
    // bad URL, fall through
  }
  return env;
}

export const API = resolveApiBase();
export default API;
